import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TabsContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    hidden: {
        display: "none"
    },
    fill: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    orientation,
    isHidden,
    radiuses,
    borders,
    colors
}: TabsContentDynamicStyleType) => {
    const styles = {
        container: {
            ...getCornerStyle({
                radius: radiuses.surface,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.container, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    if(orientation === "vertical") {
        Object.assign(styles.container, stylesheet.fill);
    }

    if(isHidden) {
        Object.assign(styles.container, stylesheet.hidden);
    }

    return styles;
};
export default stylesheet;
